module.exports = __webpack_public_path__ + "img/bread-slice (1).6787d910.png";